import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import type { RecommendationStatsResponse } from '../../../recommendations/types';

interface UseGetRecommendationsStatsParams {
	areaId?: string | string[];
	startDate?: string;
	endDate?: string;
	forBinding?: string;
	enabled?: boolean;
}

export const useGetRecommendationsStats = ({
	areaId,
	startDate,
	endDate,
	forBinding: explicitForBinding,
	enabled = true,
}: UseGetRecommendationsStatsParams = {}) => {
	const contextForBinding = useForBindingId();
	const forBinding = explicitForBinding || contextForBinding;

	return useQuery({
		queryKey: ['advices', 'stats', forBinding, areaId, startDate, endDate],
		enabled,
		placeholderData: (previousData, previousQuery) =>
			previousQuery?.queryKey[2] === forBinding
				? previousData
				: undefined,
		queryFn: async () => {
			const params = new URLSearchParams();

			if (forBinding) params.set('forBinding', forBinding);
			if (startDate) params.set('startDate', startDate);
			if (endDate) params.set('endDate', endDate);

			const areaIds = Array.isArray(areaId) ? areaId : areaId ? [areaId] : [];
			for (const id of areaIds) params.append('areaId', id);

			const { data } = await api.get<RecommendationStatsResponse>('/advices/stats', {
				params,
			});
			return data;
		},
	});
};
